import { render } from "./Form.vue?vue&type=template&id=9c370384&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=9c370384&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9c370384"

export default script